import { baseBetaBranches, baseProdBranches } from "@/features/constants"

/**
 * Get Epochs GraphQL base URL based on branch
 * Uses scale.api/v2/protocol/graphql endpoint
 */
export function getEpochGraphQlBaseUrl(branch: string): string {
  let baseUrl = ""
  // Then, fall back to branch-specific env vars
  if (baseProdBranches.includes(branch)) {
    baseUrl = import.meta.env.VITE_PROD_SCALE_PROXY_API || ""
  }

  if (baseBetaBranches.includes(branch)) {
    baseUrl = import.meta.env.VITE_BETA_SCALE_PROXY_API || ""
  }

  if (import.meta.env.VITE_SCALE_PROXY_API) {
    baseUrl = import.meta.env.VITE_SCALE_PROXY_API || ""
  }

  if (!baseUrl) {
    throw new Error(`Branch "${branch}" not supported for Epoch GraphQL API`)
  }

  const fullUrl = `${baseUrl}/v2/protocol/graphql`

  return fullUrl
}
